import _ from 'lodash';
import { defaultViewPropsGetter } from 'library-@/utils/get-params';
import store from '../vuex/store';
export const pluginsMapByName = new Map();
export const comparePluginsMapByName = new Map();
export let manifests = [];
export let compareManifests = [];

export const routeAppender = {
    components: {},
    props: {},
    children: [],
};

export const compareRouteAppender = {
    components: {},
    props: {},
    children: [],
};

export const SIDES = {
    LEFT: 'left',
    RIGHT: 'right',
    SINGLE: 'single',
};
const requireAll = context => context.keys()
    .map(context);

const allManifests = [
    // eslint-disable-next-line
    ...requireAll(require.context('./', true, /manifest\.js/)),
    // CAS微前端入口
    // eslint-disable-next-line
    ...requireAll(require.context('./CAS/', true, /manifest\.js/)),
    // 支持用Alias指向第三方包的文件夹，可以是node_module
    // ...requireAll(require.context('@analytics/patentViewSubView', false, /manifest\.js/))
]
    .map(item => (_.get(item, 'default.name') ? item.default : item));

export const fullViewRouterNames = allManifests
    .filter((item) => item.fullView)
    .map(item => item.name);

export function install() {
    manifests = allManifests
        .filter(mf => mf.left || mf.right) // 没有子的
        .sort(function(a, b) {
            return (a.tabIndex - b.tabIndex);
        });

    manifests.forEach((pluginManifest) => {
        if (pluginsMapByName.has(pluginManifest.name)) {
            console.error(`Same subViewComponent name found: ${pluginManifest.name}`);
        }
        pluginsMapByName.set(pluginManifest.name, { ...pluginManifest });
        routeAppender.components[pluginManifest.name] = pluginManifest.getComponent;

        routeAppender.props[pluginManifest.name] = (route) => {
            return {
                ...defaultViewPropsGetter(route),
                pluginsMapByName,
            };
        };
    });

    return routeAppender;
}

export function installCompareViewPlugins() {
    compareManifests = allManifests
        .filter(mf => mf.compareView) // 没有子的
        .sort(function(a, b) {
            return (a.tabIndex - b.tabIndex);
        });

    compareManifests.forEach((pluginManifest) => {
        if (comparePluginsMapByName.has(pluginManifest.name)) {
            console.error(`Same subViewComponent name found: ${pluginManifest.name}`);
        }
        comparePluginsMapByName.set(pluginManifest.name, { ...pluginManifest });
        compareRouteAppender.components[pluginManifest.name] = pluginManifest.getComponent;

        compareRouteAppender.props[pluginManifest.name] = (route) => {
            return {
                ...defaultViewPropsGetter(route),
                comparePluginsMapByName,
            };
        };
    });

    return compareRouteAppender;
}

export function installTopViewPlugins() {

    const routes = [
        // {
        //     path: `/overview`,
        //     props: defaultViewPropsGetter,
        //     component: Overview,
        //     children: [
        //         {
        //             path: '/thumb',
        //             name: 'overview/thmb',
        //             component: Thumb
        //         },
        //     ]
        // }
    ];

    let topManifests = allManifests
        .filter(mf => mf.exclusiveRoutePath);

    topManifests.forEach((pluginManifest) => {
        pluginsMapByName.set(pluginManifest.name, { ...pluginManifest });

        const pluginManifestChildren = (pluginManifest.children || []);
        const routeItemTop = {
            meta: {
                pluginName: pluginManifest.name,
            },
            path: pluginManifest.exclusiveRoutePath,
            props: defaultViewPropsGetter,
            component: pluginManifest.getComponent,
        };

        if (pluginManifestChildren.length) {
            routeItemTop.children = [];
        }
        pluginManifestChildren.forEach((subviewPluginName, index) => {
            const subViewManifest = pluginsMapByName.get(subviewPluginName);
            if (!subViewManifest) {
                throw Error(`manifests of ${subviewPluginName} invalid: No children ${subviewPluginName}: ${JSON.stringify(pluginManifest.children)}`);
            }
            if (!subViewManifest.singleView) {
                console.error(`${subViewManifest.name} not allowed in singleView! (Required via ${pluginManifest.name})`);
            }
            if (index === 0) {
                routeItemTop.children.push({
                    path: '',
                    name: pluginManifest.name,
                    redirect: {
                        name: `${pluginManifest.name}/${subViewManifest.name}~exclusiveRoutePath`,
                    },
                });
            }
            routeItemTop.children.push({
                path: `${subViewManifest.name}`,
                name: `${pluginManifest.name}/${subViewManifest.name}~exclusiveRoutePath`,
                component: subViewManifest.getComponent,
                props: defaultViewPropsGetter,
            });
        });

        routes.push(routeItemTop);
    });
    return routes;
}

export function getFilteredManifestList(side, $store = store) {
    let ret = _.filter(manifests, { [side]: true });
    ret = ret.filter(function(manifest) {
        if (!manifest.aclReadPath) {
            return true;
        }
        if (!$store.state) {
            console.error('getFilteredManifestList need vuex $store as 2nd param!');
        }
        return _.get($store.state, manifest.aclReadPath.replace('/', '.'));
    });
    return ret;
}

export function getFilteredCompareManifestList(side, $store = store) {
    let ret = [...compareManifests];
    ret = ret.filter(function(manifest) {
        if (!manifest.aclReadPath) {
            return true;
        }
        if (!$store.state) {
            console.error('getFilteredManifestList need vuex $store as 2nd param!');
        }
        return _.get($store.state, manifest.aclReadPath.replace('/', '.'));
    });
    return ret;
}
